import React from "react";

import { useTable, useSortBy } from "react-table";

import "bootstrap/dist/css/bootstrap.min.css";

import "../../assets/css/custom.css";

import DataLoader from "./DataLoader";



const isActionColumn = (column) => column.id === "select";



const TableContent = ({ columns, data }) => {

    const {

        getTableProps,

        getTableBodyProps,

        headerGroups,

        rows,

        prepareRow,

    } = useTable(

        {

            columns,

            data,

        },

        useSortBy

    );



    return (

        <div className="custom-table-scroll">

            <div className="table-responsive">

            <table

                className="table table-bordered table-striped table-condensed cf custom-table"

                {...getTableProps()}

            >

                <thead className="cf bg-primary text-white">

                    {headerGroups.map((headerGroup) => (

                        <tr {...headerGroup.getHeaderGroupProps()}>

                            {headerGroup.headers.map((column) => (

                                <th

                                    {...column.getHeaderProps()}

                                    className="text-center"

                                >

                                    <div className="table-header-cell">

                                        {column.id === "select" ? "Action" : column.render("Header")}

                                        {column.canSort ? (

                                            <button

                                                type="button"

                                                className="table-sort-btn"

                                                {...column.getSortByToggleProps()}

                                                aria-label={`Sort by ${column.id}`}

                                            >

                                                <i

                                                    className={`fa-solid ${

                                                        column.isSorted

                                                            ? column.isSortedDesc

                                                                ? "fa-sort-down"

                                                                : "fa-sort-up"

                                                            : "fa-sort"

                                                    }`}

                                                    aria-hidden="true"

                                                />

                                            </button>

                                        ) : null}

                                    </div>

                                </th>

                            ))}

                        </tr>

                    ))}

                </thead>

                <tbody {...getTableBodyProps()}>

                    {rows.map((row) => {

                        prepareRow(row);

                        return (

                            <tr {...row.getRowProps()}>

                                {row.cells.map((cell) => {

                                    const actionColumn = isActionColumn(cell.column);

                                    const cellClassName = actionColumn

                                        ? "text-center table-action-cell"

                                        : (cell.column.className || "text-center");



                                    return (

                                        <td {...cell.getCellProps()} className={cellClassName}>

                                            {actionColumn ? (

                                                <div className="table-action-cell-content">

                                                    {cell.render("Cell")}

                                                </div>

                                            ) : (

                                                cell.render("Cell")

                                            )}

                                        </td>

                                    );

                                })}

                            </tr>

                        );

                    })}

                </tbody>

            </table>

            </div>

        </div>

    );

};



const TableComponent = ({ columns, data, isLoading = false }) => {

    if (isLoading || data == null) {

        return <DataLoader />;

    }



    return <TableContent columns={columns} data={data} />;

};



export default TableComponent;

